const scrollContainerClassName = 'main__wrap'
const scrollEvent = 'scrollend'
const scrollValueSuffix = '_scrollPosition'

const eventListeners = new Map()

function getScrollContainer() {
  const mainWrap = document.getElementsByClassName(scrollContainerClassName)[0]
  return mainWrap?.childNodes[0]?.childNodes[0] || null
}

function getMainWrap() {
  return document.getElementsByClassName(scrollContainerClassName)[0] || null
}

export function registerScrollRestoration(pageKey) {
  const scrollContainer = getScrollContainer()
  if (!scrollContainer) return

  const scrollHandler = () => savePosition(pageKey)
  eventListeners.set(pageKey, scrollHandler)

  scrollContainer.addEventListener(scrollEvent, scrollHandler)
}

export function unregisterScrollRestoration(pageKey) {
  const scrollContainer = getScrollContainer()
  const scrollHandler = eventListeners.get(pageKey)

  if (!scrollContainer || !scrollHandler) {
    return
  }

  scrollContainer.removeEventListener(scrollEvent, scrollHandler)
  eventListeners.delete(pageKey)
}

const savePosition = pageKey => {
  const scrollContainer = getScrollContainer()
  if (!scrollContainer) return

  const scrollPosition = scrollContainer.scrollTop
  sessionStorage.setItem(pageKey + scrollValueSuffix, scrollPosition.toString())
}

export function restoreScrollPosition(pageKey) {
  const scrollPosition = sessionStorage.getItem(pageKey + scrollValueSuffix)
  if (scrollPosition) {
    scrollTo(parseInt(scrollPosition, 10))
  }
}

function scrollTo(scrollPosition) {
  const mainWrap = getMainWrap()
  const scrollContainer = getScrollContainer()

  if (!mainWrap || !scrollContainer) return

  mainWrap.scrollTop = scrollPosition
  scrollContainer.scrollTop = scrollPosition
}
